import '../css/common/loading-wrapper.css';
import '../css/common/nav-bar.css';
import '../css/common/nav-shortcut.css';
import '../css/common/dropdown-button.css';
import '../css/common/menu-btn.css';
import '../css/common/social-button.css';
import '../css/common/cookies-bar.css';

import '../css/footer/footer-wrapper.css';
import '../css/footer/nav-wrapper.css';
import '../css/footer/nav-block.css';
import '../css/footer/brands-wrapper.css';
import '../css/footer/contact-wrapper.css';
import '../css/footer/social-icons.css';



// WEBPACK FOOTER //
// ./src/js/importCommonCss.js